/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import { OfficeMeasurementDefault } from '../offices/models/office-measurement-default.enum';
import { OfficeMeasurement } from '../offices/models/office-measurement.enum';
import { SystemVarsEstimatingDto } from './system-vars-estimating.dto';

export const SystemVarsEstimatingMapper = entity<SystemVarsEstimatingDto>({
  lastPublishedDate: date(DateFormat.Date),
  itemsLoaded: date(DateFormat.DateTime),
  measurementScale: enumeration(OfficeMeasurement),
  measurementDefault: enumeration(OfficeMeasurementDefault),
});
